import bestserviceIcon from 'assets/images/bestservice.png';
import completed from 'assets/images/completed.png';
import inprogress from 'assets/images/in-progress.png';
import mvpIcon from 'assets/images/mvp.png';
import pending from 'assets/images/pending.png';
import sportsmanshipIcon from 'assets/images/sportsmanship.png';
import React from 'react';
import ReactGA from 'react-ga';
import Img from 'react-image';
import { Card, CardBody, CardHeader, CardImg, CardText, Col, Row } from 'reactstrap';

const TeamModal = (props) => {
  ReactGA.event({
    category: 'Teams',
    action: 'Modal'
  });
  if (props.players !== null) {
    return (
      <div>
        {/* <div style={{ padding: '4px', 'margin-bottom': '5px' }}>
          <Row>
            <Col>Vote team member by clicking on symbol</Col>
          </Row>
          <Row>
            <Col><Img width="24px" src={mvpIcon} />  :- MVP Votes</Col>
            <Col><Img width="24px" src={bestserviceIcon} /> :- Best Server Votes</Col>
            <Col><Img width="24px" src={sportsmanshipIcon} /> :- Sportsmanship Votes</Col>
          </Row>

        </div> */}
        {props.players}
      </div>
    )
  }
  if (props.schedule !== null) {
    return (
      <div>
        {props.schedule.map((schedule, i) => {
          var image;
          if (null != schedule.gameEntry) {
            if (schedule.gameEntry.status === "A") {
              image = <CardImg width="50px" src={inprogress} />
            } else if (schedule.gameEntry.status === 'I') {
              image = <CardImg width="50px" src={completed} />
            }
          } else {
            image = <CardImg width="50px" src={pending} />
          }

          return <Card style={{ backgroundColor: '#fefefe', padding: '4px', 'margin-bottom': '5px' }}>
            <CardHeader tag="h6">{schedule.homeTeamName}({schedule.homeTeamNo}) vs. {schedule.visitorTeamName}({schedule.visitorTeamNo})</CardHeader>
            <CardBody>
              <CardText>Round: {schedule.round}</CardText>
              <CardText>Court: {schedule.courtNo}</CardText>
              <CardText>{schedule.scheduleDate}</CardText>
              <CardText>{image}</CardText>
            </CardBody>
          </Card>
        })
        }
      </div>)
  }

  if (props.games !== null) {
    return (
      <div>
        {props.games.map((game, i) => {
          var image;
          if (game.status === "A") {
            image = <CardImg width="50px" src={inprogress} />
          } else if (game.status === 'I') {
            image = <CardImg width="50px" src={completed} />
          }
          return <Card style={{ backgroundColor: '#fefefe', padding: '4px', 'margin-bottom': '5px' }}>
            <CardBody>
              <CardText><strong>{game.homeTeam}: </strong>  ({game.homeScore})</CardText>
              <CardText><strong>vs</strong></CardText>
              <CardText><strong>{game.visitorTeam}: </strong>  ({game.visitorScore})</CardText>
              <CardText><strong>{game.gameRound} </strong> </CardText>
              <CardText>{image}</CardText>
            </CardBody>
          </Card>
        })
        }
      </div>)


  }
  return null;
}
export default TeamModal;


// WEBPACK FOOTER //
// ./src/components/TileIcon/TeamModal.js